<template>
  <!-- Categories Section -->
  <section class="categories-section">
		<div class="container">
			<div class="row">
				<div class="col-md-12 text-center">
					<div class="section-heading section-heading-four category-heading aos" data-aos="fade-up">
						<h2>Catering Service Categories</h2>
						<p>A featured services marketplace typically offers a platform where various service providers</p>
					</div>
				</div>
			</div>
			<div class="row justify-content-center">
				<div class="col-xl-3 col-lg-3 col-md-3 d-flex ">
					<router-link to="/details/service-details" class="w-100">
					<div class="categories-main-all flex-fill">
						<div class="categories-img">
							<span class="active">
								<img src="@/assets/img/icons/catering-07.svg" alt="Category">
							</span>
						</div>
						<h5>Event</h5>
						<span class="category-bottom">
							<i class="feather-chevron-right "></i>
						</span>
					</div>
					</router-link>
				</div>
				<div class="col-xl-3 col-lg-3 col-md-3 d-flex ">
					<router-link to="/details/service-details" class="w-100">
					<div class="categories-main-all flex-fill">
						<div class="categories-img">
							<span>
								<img src="@/assets/img/icons/catering-01.svg" alt="Category">
							</span>
						</div>
						<h5>Birthday Party</h5>
						<span class="category-bottom">
							<i class="feather-chevron-right "></i>
						</span>
					</div>
					</router-link>
				</div>
				<div class="col-xl-3 col-lg-3 col-md-3 d-flex ">
					<router-link to="/details/service-details" class="w-100 h-100">
					<div class="categories-main-all flex-fill">
						<div class="categories-img">
							<span>
								<img src="@/assets/img/icons/catering-02.svg" alt="Category">
							</span>
						</div>
						<h5>Indoor </h5>
						<span class="category-bottom">
							<i class="feather-chevron-right "></i>
						</span>
					</div>
					</router-link>
				</div>
				<div class="col-xl-3 col-lg-3 col-md-3 d-flex ">
					<router-link to="/details/service-details" class="w-100">
					<div class="categories-main-all ">
						<div class="categories-img">
							<span>
								<img src="@/assets/img/icons/catering-03.svg" alt="Category">
							</span>
						</div>
						<h5>Outdoor</h5>
						<span class="category-bottom">
							<i class="feather-chevron-right "></i>
						</span>
					</div>
					</router-link>
				</div>
				<div class="col-xl-3 col-lg-3 col-md-3 d-flex ">
					<router-link to="/details/service-details" class="w-100">
					<div class="categories-main-all ">
						<div class="categories-img">
							<span>
								<img src="@/assets/img/icons/catering-04.svg" alt="Category">
							</span>
						</div>
						<h5>International  </h5>
						<span class="category-bottom">
							<i class="feather-chevron-right "></i>
						</span>
					</div>
					</router-link>
				</div>
				<div class="col-xl-3 col-lg-3 col-md-3 d-flex ">
					<router-link to="/details/service-details" class="w-100">
					<div class="categories-main-all ">
						<div class="categories-img">
							<span>
								<img src="@/assets/img/icons/catering-08.svg" alt="Category">
							</span>
						</div>
						<h5>Buffet</h5>
						<span class="category-bottom">
							<i class="feather-chevron-right "></i>
						</span>
					</div>
					</router-link>
				</div>
				<div class="col-xl-3 col-lg-3 col-md-3 d-flex ">
					<router-link to="/details/service-details" class="w-100">
					<div class="categories-main-all ">
						<div class="categories-img">
							<span>
								<img src="@/assets/img/icons/catering-05.svg" alt="Category">
							</span>
						</div>
						<h5>Kitty Party</h5>
						<span class="category-bottom">
							<i class="feather-chevron-right "></i>
						</span>
					</div>
					</router-link>
				</div>
				<div class="col-xl-3 col-lg-3 col-md-3 d-flex ">
					<router-link to="/details/service-details" class="w-100">
					<div class="categories-main-all ">
						<div class="categories-img">
							<span>
								<img src="@/assets/img/icons/catering-06.svg" alt="Category">
							</span>
						</div>
						<h5>Party </h5>
						<span class="category-bottom">
							<i class="feather-chevron-right "></i>
						</span>
					</div>
					</router-link>
				</div>
				<div class="btn-sec btn-catering aos" data-aos="fade-up">
					<router-link to="/service-categories/categories" class="btn btn-primary btn-view">View all Categories<i class="feather-arrow-right"></i></router-link>
				</div>
			</div>
		</div>
	</section>

  <!-- /Categories Section -->

  <!-- Features Services -->
  <section class="features-four-section">
    <div class="container">
      <div class="section-heading section-heading-four">
        <div class="row align-items-center row-gap-3">
			<div class="col-md-6 aos" data-aos="fade-up">
				<h2>Featured Cateres</h2>
				<p>Explore the greatest our services. You won’t be disappointed</p>
			</div>
			<div class="col-md-6 text-md-end aos" data-aos="fade-up">
				<router-link to="/service/services-list" class="btn btn-primary btn-view">View all Caterers<i
						class="feather-arrow-right"></i></router-link>
			</div>
		</div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="owl-carousel popular-slider-2 common-four-slider">
            <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
              <Slide v-for="item in indexfourfeatured" :key="item.id">
                <div
                  class="service-widget service-two aos" data-aos="fade-up"
                >
                  <div class="service-img service-four-img">
                    <router-link to="/details/service-details">
                      <img
                        class="img-fluid serv-img"
                        alt="Service Image"
                        :src="require(`@/assets/img/catering/${item.image}`)"
                      />
                    </router-link>
                    <div class="fav-item">
                      <div class="rate-four">
                        <i class="fa-solid fa-star filled me-1"></i
                        ><span>{{ item.star }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="service-content service-four-content text-start">
                    <h3 class="title">
                      <router-link to="/details/service-details">{{ item.title }}</router-link>
                    </h3>
                    <p class="service-cater-bottom">
                      <i class="feather-map-pin me-2"></i>{{ item.city }}
                    </p>
                    <p>
                      we are also engage in offering catering services and decoration
                      services where vision...
                    </p>
                    <ul>
                      <li>{{ item.list1 }}</li>
                      <li>{{ item.list2 }}</li>
                      <li>{{ item.list3 }}</li>
                    </ul>
                    <div class="category-feature-bottom">
                      <p>{{ item.rate }}</p>
                      <router-link to="/home/">Book Now</router-link>
                    </div>
                  </div>
                </div>
              </Slide>
              <template #addons>
                <Pagination />
              </template>
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Features Services -->
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import indexfourfeatured from "@/assets/json/indexfourfeatured.json";
import "vue3-carousel/dist/carousel.css";
export default {
  data() {
    return {
      indexfourfeatured: indexfourfeatured,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
        loop: true,
        margin: 24,
      },

      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 991px and up
        991: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
};
</script>
